import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { colors } from '../../../../../constants/colors';
import { smallerThanOrEqualTo } from '../../../../../core/util/styledComponents';
import ConnectedBookModule from './ConnectedBookModule';

export const BOOKING_TIME_SELECTOR_MODAL = 'booking time selector modal';

const SmoothDialog = styled(Dialog)`
  -webkit-font-smoothing: antialiased;
  -webkit-overflow-scrolling: touch;
`;

const Container = styled.div`
  background-color: white;
  display: block;
`;

const Close = styled.div`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 18px;
  top: 21px;
  cursor: pointer;
  margin: 0 0 -10px auto;
  ${smallerThanOrEqualTo.md`
    margin 0 0 0 auto;
  `}

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.squid};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.squid};
  }
`;

const StyledBookModule = styled(ConnectedBookModule)`
  width: 100%;
  border: none;
`;

class Modal extends PureComponent {
  static propTypes = {
    location: PropTypes.object,
    fetchLocationSlotsData: PropTypes.func,
    handleRequestAppointmentClick: PropTypes.func,
    accountSummary: PropTypes.object,
    login: PropTypes.object,
    fullScreen: PropTypes.bool,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    reasonForVisit: PropTypes.string,
    suggestions: PropTypes.array,
    setBookingProfile: PropTypes.func,
    requestAppointmentData: PropTypes.object,
  };

  componentDidUpdate = prevProps => {
    if (!prevProps.requestAppointmentData && this.props.requestAppointmentData) {
      const { appointmentTime } = this.props.requestAppointmentData;
      this.props.handleRequestAppointmentClick(
        appointmentTime,
        this.props.login,
        null,
        this.props.location
      );
    }
  };

  render() {
    const {
      fetchLocationSlotsData,
      handleRequestAppointmentClick,
      setBookingProfile,
      accountSummary,
      fullScreen,
      location,
      onClose,
      open,
      login,
      suggestions,
      reasonForVisit,
    } = this.props;
    return (
      <SmoothDialog
        open={open}
        onClose={onClose}
        maxWidth="xs"
        scroll="body"
        fullWidth
        fullScreen={fullScreen}
      >
        <Container>
          <Close onClick={onClose} />
          <ConnectedBookModule
            autoFocus
            login={login}
            handleRequestAppointmentClick={handleRequestAppointmentClick}
            location={location}
            fetchLocationSlotsData={fetchLocationSlotsData}
            accountSummary={accountSummary}
            suggestions={suggestions}
            setBookingProfile={setBookingProfile}
            reasonForVisit={reasonForVisit}
          />
        </Container>
      </SmoothDialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'xs' })(Modal);
